import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/Button'

const STORAGE_KEY = 'gia-cookie-consent'

/**
 * Cookie consent banner (Website Review V3). Records the visitor's choice in
 * localStorage. Analytics/functional cookies should check this value before
 * loading (GA4 is not wired up yet — see Privacy Policy §6).
 */
export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true)
    } catch {
      // storage unavailable — don't nag on every load
    }
  }, [])

  function choose(value: 'accepted' | 'declined') {
    try {
      localStorage.setItem(STORAGE_KEY, value)
    } catch {
      // ignore
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-surface/15 bg-ink-deep text-surface"
    >
      <div className="mx-auto flex max-w-[88rem] flex-col gap-4 px-6 py-5 sm:px-10 md:flex-row md:items-center md:justify-between">
        <p className="max-w-2xl text-sm leading-relaxed text-surface/85">
          We use cookies to keep the site working and to understand how it is
          used. You can accept or decline analytics cookies. See our{' '}
          <a
            href="/privacy"
            className="font-bold text-surface underline decoration-1 underline-offset-2 hover:no-underline"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex shrink-0 items-center gap-3">
          <button
            type="button"
            onClick={() => choose('declined')}
            className="text-xs font-bold uppercase tracking-[0.1em] text-surface/75 hover:text-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-surface focus-visible:ring-offset-2 focus-visible:ring-offset-ink-deep"
          >
            Decline
          </button>
          <Button variant="inverse" size="sm" onClick={() => choose('accepted')}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  )
}
